module.exports = __webpack_public_path__ + "../resources/images/illustration_attachment-959af1ae45ab4a895640a0d35f65bb3a.svg";